import { Injectable } from '@angular/core';
import { Toast } from '../interfaces/toast';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  public toasts: Toast[] = [];

  constructor() {}

  alert(message: string): Toast {
    const alertToast: Toast = {
      delay: 12500,
      message,
      classname: 'bg-danger text-light',
      header: '❌ error',
    };

    this.toasts.push(alertToast);

    return alertToast;
  }

  success(message: string): Toast {
    const successToast: Toast = {
      delay: 4000,
      message,
      classname: 'bg-success text-light',
      header: '✅ Acción exitosa.',
    };

    this.toasts.push(successToast);

    return successToast;
  }

  warning(message: string): Toast {
    const warningToast: Toast = {
      delay: 10000,
      message,
      classname: 'bg-warning text-dark',
      header: '⚠️  Advertencia',
    };

    this.toasts.push(warningToast);

    return warningToast;
  }

  secondary(message: string): Toast {
    const secondaryToast: Toast = {
      delay: 10000,
      message,
      classname: 'bg-secondary text-light',
      header: 'Nota',
    };

    this.toasts.push(secondaryToast);

    return secondaryToast;
  }

  remove(toast: Toast): void {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }
}
